import { render } from "./AddParc.vue?vue&type=template&id=fc2723e8"
import script from "./AddParc.vue?vue&type=script&lang=js"
export * from "./AddParc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__